var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.764 10.9999C17.764 10.5444 17.7019 10.1304 17.6398 9.69557L20 7.60447L17.9296 4.02269L14.9275 5.03718C14.265 4.47818 13.5197 4.04339 12.6915 3.73283L12.0704 0.647949H7.92961L7.30849 3.73283C6.48033 4.04339 5.73499 4.47818 5.07246 5.03718L2.07039 4.02269L0 7.60447L2.36025 9.69557C2.29814 10.1304 2.23602 10.5444 2.23602 10.9999C2.23602 11.4554 2.29814 11.8695 2.36025 12.3043L0 14.3954L2.07039 17.9771L5.07246 16.9626C5.73499 17.5217 6.48033 17.9564 7.30849 18.267L7.92961 21.3519H12.0704L12.6915 18.267C13.5197 17.9564 14.265 17.5217 14.9275 16.9626L17.9296 17.9771L20 14.3954L17.6398 12.3043C17.7019 11.8695 17.764 11.4554 17.764 10.9999ZM10 15.1407C7.72257 15.1407 5.85921 13.2773 5.85921 10.9999C5.85921 8.72248 7.72257 6.85913 10 6.85913C12.2774 6.85913 14.1408 8.72248 14.1408 10.9999C14.1408 13.2773 12.2774 15.1407 10 15.1407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.43b2b35709481a00fda98fcbe4e652e4.svg";
export { ForwardRef as ReactComponent };